<template>
  <div class="py-4 space-y-6">
    <!-- Title -->
    <div class="text-center mb-6">
      <h1 class="text-xl font-bold text-foreground mb-2">
        {{ $t('report.members_activity_info.title') }}
      </h1>
      <p class="text-sm text-muted-foreground leading-relaxed max-w-xs mx-auto">
        {{ $t('report.members_activity_info.description') }}
      </p>
    </div>

    <!-- How to read -->
    <div class="space-y-4">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_activity_info.how_to_read') }}
        </h2>
      </div>

      <!-- Indicator descriptions -->
      <div class="space-y-3">
        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #10B981"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_activity_info.recency_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_activity_info.recency_desc') }}
            </p>
          </div>
        </div>

        <div class="flex items-start gap-2.5">
          <span class="w-2.5 h-2.5 rounded-full shrink-0 mt-1" style="background: #06C8FF"></span>
          <div>
            <span class="text-xs font-semibold text-foreground">{{ $t('report.members_activity_info.purchase_label') }}</span>
            <p class="text-xs text-muted-foreground leading-relaxed mt-0.5">
              {{ $t('report.members_activity_info.purchase_desc') }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Note -->
    <div class="space-y-2">
      <div class="flex items-center gap-2">
        <div class="w-1 h-3.5 rounded-full" style="background: #06C8FF"></div>
        <h2 class="text-sm font-bold uppercase tracking-wide text-foreground">
          {{ $t('report.members_activity_info.note_label') }}
        </h2>
      </div>
      <p class="text-xs text-muted-foreground leading-relaxed ml-3">
        {{ $t('report.members_activity_info.note') }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
// Content-only component — no props needed.
// Injected into a BottomSheet from CenterMembersReport.
</script>
